import _ from "lodash";
import { request } from "@/service";
import constants from "@/modules/dashboard/dashboardConstants";

export default {
  namespaced: true,
  state: {
    links: [
      {
        to: "/dashboard/summary",
        order: 1,
        icon: "mdi-gauge",
        title: "Dashboard",
        disabled: false,
      },
    ],
    reviewStats: null,
    dateStatistics: null,
    reviewLogs: [],
    assignedGrantApplications: [],
    cueueApplications: [],
    applicationComments: [],
  },
  mutations: {
    SET_LINKS: (state, payload) => {
      if (_.findIndex(state.links, payload) === -1) {
        state.links.push(payload);
      }
    },

    SET_REVIEW_STATS: (state, payload) => {
      state.reviewStats = payload;
    },

    SET_DATE_STATISTICS: (state, payload) => {
      state.dateStatistics = payload;
    },

    SET_REVIEW_LOGS: (state, payload) => {
      state.reviewLogs = payload;
    },
    SET_CUEUE_APPLICATIONS: (state, payload) => {
      state["cueueApplications"] = payload;
    },
    SET_APPLICATION_COMMENTS: (state, payload) => {
      state["applicationComments"] = payload;
    },
  },

  getters: {
    loading: (state) => state.loading,
    links: (state) => {
      return _.orderBy(state.links, (link) => link.order);
    },
    reviewStats: (state) => state.reviewStats,
    dateStatistics: (state) => state.dateStatistics,
    reviewLogs: (state) => state.reviewLogs,
    getCueueApplications: (state) => state["cueueApplications"],
    getApplicationComments: (state) => state["applicationComments"],
  },

  actions: {
    fetchCueueApplications: ({ commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_CUEUE_APPLICATIONS", []);
      const endpoints = {
        Application: "applicationRequest",
        Upgrade: "upgradeRequestAPI",
      };
      const { resource, ...rest } = payload;
      request("get", constants.cueueApplications(endpoints[resource], rest))
        .then((response) => {
          commit("SET_CUEUE_APPLICATIONS", response.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_ALERT", {
            status: "error",
            message: error?.response?.data?.message || error.message,
          });
          commit("SET_LOADING", false, { root: true });
        });
    },
    fetchApplicationComments({ commit }, payload) {
      commit("SET_LOADING", true, { root: true });
      commit("SET_APPLICATION_COMMENTS", []);
      request("get", constants.getApplicationComments(payload))
        .then((response) => {
          commit("SET_APPLICATION_COMMENTS", response.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_ALERT", {
            status: "error",
            message: error?.response?.data?.message || error.message,
          });
          commit("SET_LOADING", false, { root: true });
        });
    },
    getReviewStats: ({ commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      request("post", constants.reviewStatistics, payload)
        .then((res) => {
          commit("SET_REVIEW_STATS", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          commit("SET_LOADING", false, { root: true });
        });
    },

    getDateStatistics: ({ commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      request("post", constants.dateStatistics, payload)
        .then((res) => {
          commit("SET_DATE_STATISTICS", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          commit("SET_LOADING", false, { root: true });
        });
    },

    getReviewLogs: ({ commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      request("get", constants.reviewLogs, payload)
        .then((res) => {
          commit("SET_REVIEW_LOGS", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
          commit("SET_LOADING", false, { root: true });
        });
    },
  },
};
